module.exports = __webpack_public_path__ + "img/fcb-logo-cn.8c057f77.png";